function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ConsoleRequestLogger, ConsoleLoggerFactory, RpcLoggerFactory } from '@square/ember-rpc-client/utils';
import { decodeAnyRecursively, isAnyEndpoint } from '@square/dashboard-utilities/utils/decode-any';
export class AnyDecodingConsoleRequestLogger extends ConsoleRequestLogger {
  logRequest(method, url, requestData) {
    const resolved = method.resolve();
    const {
      resolvedRequestType
    } = resolved;
    this.console.groupCollapsed(`%cRPC#${this.id} ↑ %c${url}`, 'color:blue', `color:${this.getColor()}`);
    const decoded = resolvedRequestType.decode(requestData);
    const serviceName = (method.parent?.fullName ?? '').replace(/^\./, '');
    if (isAnyEndpoint(serviceName, method.name)) {
      this.console.log(decodeAnyRecursively(decoded));
    } else {
      this.console.log(decoded);
    }
    this.console.groupEnd();
  }
  logResponse(method, url, responseData) {
    const resolved = method.resolve();
    const {
      resolvedResponseType
    } = resolved;
    this.console.groupCollapsed(`%cRPC#${this.id} ↓ %c${url}`, 'color:green', `color:${this.getColor()}`);
    const decoded = resolvedResponseType.decode(responseData);
    const serviceName = (method.parent?.fullName ?? '').replace(/^\./, '');
    if (isAnyEndpoint(serviceName, method.name)) {
      this.console.log(decodeAnyRecursively(decoded));
    } else {
      this.console.log(decoded);
    }
    this.console.groupEnd();
  }
}
export class AnyDecodingConsoleLoggerFactory extends RpcLoggerFactory {
  constructor(enabled) {
    super(AnyDecodingConsoleRequestLogger);
    _defineProperty(this, "_enabled", void 0);
    this._enabled = enabled;
  }
  build() {
    if (!this._enabled) {
      return new ConsoleLoggerFactory(false).build();
    }
    return super.build();
  }
}